import { type Component, For } from "solid-js";
import AlphaLogo from "~/Icons/testimonials/AlphaReviewLogo.svg?component-solid";
import YandexLogo from "~/Icons/testimonials/YandexReviewLogo.svg?component-solid";
import type { FeedBackListItem } from "../model";
import { PricingFeedBackCard } from "./PricingFeedBackCard";

export const CommentAndReviewsSection: Component = () => {
	const feedbackData: FeedBackListItem[] = [
		{
			name: "Timur Ramazanov",
			position: "Director, Head of animation studio",
			feedBack: `I've tried many web tools, and so far Phygital+ is the best one. It's very convenient to use "out of the box." It's a perfect product for those who want a flexible solution that doesn't require much learning time. Another advantage is its community: the team is always there to help, and the project grows fast`,
			userPick:
				"https://cdn.phgtlsm.com/phygital-plus-editor/airtableFiles/pricing/avatars/Userpic-2.png",
			Icon: AlphaLogo
		},
		{
			name: "Anna Poliakova",
			position: "Artist",
			feedBack: `The most accessible and easy-to-use AI tool for artists. You don't need to figure out colabs or difficult payments. You get the most popular useful neural networks in one place.`,
			userPick:
				"https://cdn.phgtlsm.com/phygital-plus-editor/airtableFiles/pricing/avatars/Userpic-3.png",
			Icon: YandexLogo
		},
		{
			name: "Oleg Zavorotnyi",
			position: "AI Artist",
			feedBack: `Phygital+ Al Tool is an incredible
tool that will save you a lot of
time. With it, you can invest your
time not in the endless Al models
setup, but in art and creativity.`,
			userPick:
				"https://cdn.phgtlsm.com/phygital-plus-editor/airtableFiles/pricing/avatars/Userpic.png",
			Icon: AlphaLogo
		}
	];

	return (
		<div class="flex w-full flex-col items-center justify-center gap-10">
			<div class="md:header-48-semibold w-full px-6 text-left font-semibold text-3xl text-black md:px-0">
				Comments & Reviews
			</div>
			<div class="flex h-80 w-full items-center justify-start gap-3 overflow-x-auto pl-6 md:pl-0 xl:justify-center">
				<For each={feedbackData}>{(item) => <PricingFeedBackCard {...item} />}</For>
			</div>
		</div>
	);
};
